///////////////////////////////////////////////
// --- CSS --- ////////////////////////////////

import '../scss/corporate.scss';


//////////////////////////////////////////////
// --- JS --- ////////////////////////////////

import {CookieConsent} from './ui/cookie-consent';
import {LandingView} from './views/landing-view';

import {RSUrlHelper} from '../be/redskythirty/helpers/url';


// Script

(() => {
	const ready = (callback) => {
		if (document.readyState !== 'loading') callback();
		else document.addEventListener('DOMContentLoaded', callback);
	};


	ready(() => {
		const elPageBody = document.querySelector('.js-page-body');
		
		const bodyId = document.body.getAttribute('id');

		switch (bodyId)
		{
			case 'landing' :
				new LandingView(elPageBody);
				break;
		}
		
		
		const elCookieConsent = document.querySelector('.js-cookie-consent');
		
		if (elCookieConsent != null)
		{
			new CookieConsent(elCookieConsent);
		}
		
		
		if (RSUrlHelper.getUriVariables() != null)
		{
			RSUrlHelper.removeUriVariables();
		}
	});
})();

